// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--1DUjz","list":"list--3SlUC","containerDiv":"containerDiv--1nYtX","search":"search--2R_AG","create_btn":"create_btn--Lc0By","breadcrumb":"breadcrumb--2ilo2"};